// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15W9E","importantInfo":"styles_importantInfo__3wNfv"};